import styled from 'styled-components';
import getColor from 'utils/getColor';
import getAlignment from 'utils/getAlignment';

const ContentfulRichTextContainer = styled.div`
  position: relative;
  background-color: ${({ backgroundColor }) => backgroundColor && getColor(backgroundColor)};
  text-align: ${({ textAlignment }) => textAlignment && getColor(textAlignment)};
  ${({ alignDesktop, alignMobile }) => {
    if (alignDesktop || alignMobile) {
      const alignValue = alignDesktop || alignMobile;
      const { flexAlignment, textAlignment } = getAlignment(alignValue);

      return `
        align-items: ${flexAlignment};
        text-align: ${textAlignment};
        `;
    }
  }};
  ${({ backgroundImageUrl }) => {
    if (backgroundImageUrl) {
      return `
        background: url(${backgroundImageUrl}); 
        background-position: center; 
        background-size: cover;`;
    }
  }};
  border-width: ${({ border }) => border};
  border: ${({ borderColor }) => borderColor && `${getColor(borderColor)} solid`};
  display: ${({ hideOnDesktop }) => (hideOnDesktop ? 'none' : 'flex')};
  flex-direction: column;
  height: ${({ heightDesktop, heightMobile }) => heightDesktop || heightMobile || 'max-content'};
  margin: ${({ marginMobile, marginDesktop }) => marginDesktop || marginMobile};
  padding: ${({ paddingMobile, paddingDesktop }) => paddingDesktop || paddingMobile};
  width: 100%;

  p:empty {
    display: none;
  }

  ul {
    padding-left: ${({ listIcon }) => listIcon && '22px'};
  }

  li {
    ${({ listIcon }) => {
      if (listIcon) {
        return `
          list-style: none;
          display: flex;

          p {
            margin-left: 10px;
          }

          &:before {
          content: '';
          display: inline-block;
          height: 27px;
          width: 31px;
          background-image: url(${listIcon});
          background-size: contain;
          background-repeat: no-repeat;
          margin-top: 1px;
        }
      `;
      }
    }}
  }

  .richtext-toc {
    position: -webkit-sticky;
    position: sticky;
    top: 140px;
    width: 341px;
  }

  @media (max-width: 576px) {
    align-items: center;
    ${({ alignMobile }) => {
      if (alignMobile) {
        const { flexAlignment, textAlignment } = getAlignment(alignMobile);

        return `
            align-items: ${flexAlignment};
            text-align: ${textAlignment};
        `;
      }
    }};
    display: ${({ hideOnMobile }) => (hideOnMobile ? 'none' : 'flex')};
    flex-direction: column;
    height: ${({ heightMobile }) => heightMobile || 'max-content'};
    margin: ${({ marginMobile }) => marginMobile};
    padding: ${({ paddingMobile }) => paddingMobile};
    text-align: center;

    ul {
      padding: 0;
      margin: 0;
    }
  }
`;

export { ContentfulRichTextContainer };
